import styled from 'styled-components';

export const ReferrerAccountWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ReferrerAccountInfo = styled.div<{ isExpired: boolean }>`
  color: ${props => (props.isExpired ? 'grey' : 'black')};
`;